class CarouselIndicators extends HTMLElement {
  constructor() {
    super();
    this.autoplaySpeed = (this.dataset.autoplaySpeed) ? parseInt(this.dataset.autoplaySpeed) * 1000 : 0;
    this.breakpointDesktop = (this.dataset.breakpointDesktop) ? parseInt(this.dataset.breakpointDesktop) : 750;
    this.autoplay = (this.autoplaySpeed > 0) ? true : false;
    this.slider = document.querySelector(this.dataset.targetEl);
    this.groups = {
      mobile: parseInt(this.dataset.groupMobile) || 1,
      desktop: parseInt(this.dataset.groupDesktop) || 1,
    };
    this.isCarouselGenderSpecific = this.dataset.genderSpecific || false;

    this.init();

    if(this.isCarouselGenderSpecific == 'true') {
      const attrObserver = new MutationObserver((mutations) => {
        mutations.forEach(mu => {
          if (mu.type !== "attributes" && mu.attributeName !== "class") return;
          this.init();
        });
      });

      attrObserver.observe(document.body, { attributes: true });
    }
  }

  init() {
    if (!this.slider) {
      return;
    }

    this.genderPreference = getCookie('genderPreference');

    this.normalSlides = this.slider.querySelectorAll('ul > li');
    this.maleSlides = this.slider.querySelectorAll('ul > li.image-male');
    this.femaleSlides = this.slider.querySelectorAll('ul > li.image-female');

    this.maleSliderIndicators = this.querySelectorAll('ul > li.image-male-indicator');
    this.femaleSliderIndicators = this.querySelectorAll('ul > li.image-female-indicator');
    this.normalSliderIndicators = this.querySelectorAll('ul > li');

    if(this.genderPreference == 'male' && this.isCarouselGenderSpecific == 'true' && this.maleSlides.length > 0) {
      this.slides = this.maleSlides;
      this.sliderIndicators = Array.from(this.maleSliderIndicators);
    } else if (this.genderPreference == 'female' && this.isCarouselGenderSpecific == 'true' && this.femaleSlides.length > 0) {
      this.slides = this.femaleSlides;
      this.sliderIndicators = Array.from(this.femaleSliderIndicators);
    } else {
      this.slides = this.normalSlides;
      this.sliderIndicators = Array.from(this.normalSliderIndicators);
    }

    this.currentSlideIndex = 0; // Initialize the current slide index.
    this.setHidden(this.sliderIndicators.length <= 1);

    if (this.hidden) {
      return;
    }

    // Flag to track if the slider is in view.
    this.sliderInView = false;

    // Create an Intersection Observer to watch the slider element.
    this.sliderObserver = new IntersectionObserver(this.handleSliderIntersection.bind(this), {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    });

    if (this.slider) {
      this.sliderObserver.observe(this.slider);
    }

    this.observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.observerOptions);

    this.slides.forEach((slide, index) => {
      this.observer.observe(slide);
      slide.dataset.slideIndex = index;
    });

    this.autoplayInterval = null; // Store the autoplay interval ID.
  }

  getGroupValue() {
    if (window.innerWidth > this.breakpointDesktop) {
      return this.groups.desktop;
    }

    return this.groups.mobile;
  }

  setHidden(hidden) {
    this.hidden = hidden;

    if (hidden) {
      this.stopAutoplay();
      this.style.setProperty('display', 'none', 'important');
    } else {
      this.style.removeProperty('display');
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry, index) => {
      const slide = entry.target;
      const slideIndex = Math.floor(slide.dataset.slideIndex / this.getGroupValue());
      if (entry.isIntersecting) {
        this.activateSlide(slideIndex);
      }
    });
  }

  handleSliderIntersection(entries) {
    entries.forEach((entry) => {
      this.sliderInView = entry.isIntersecting;

      // Start or stop autoplay based on the slider's visibility.
      if (this.sliderInView) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    });
  }

  activateSlide(slideIndex) {
    const activeSlide = this.sliderIndicators.find((slide) => slide.classList.contains('active'));
    if (activeSlide) {
      activeSlide.classList.remove('active');
    }

    const targetSlide = this.sliderIndicators[slideIndex];
    if (targetSlide) {
      targetSlide.classList.add('active');
    }
  }

  // Method to start autoplay.
  startAutoplay() {
    if (this.hidden) {
      return;
    }

    if (this.autoplay && !this.autoplayInterval) {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, this.autoplaySpeed);
    }
  }

  // Method to stop autoplay.
  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  // Method to move to the next slide.
  nextSlide() {
    const groupSize = this.getGroupValue();
    const nextIndex = (this.currentSlideIndex + groupSize) % this.slides.length;
    this.slides[nextIndex].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    });
    this.currentSlideIndex = nextIndex;
  }

  connectedCallback() {
    const buttons = this.querySelectorAll('button');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const maleIndicatorIndex = this.sliderIndicators.indexOf(button.parentElement);
        let targetIndex = [...this.slides].indexOf(this.slides[maleIndicatorIndex]);

        this.slides[targetIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      });
    });

    // Start autoplay when the element is connected to the DOM.
    this.startAutoplay();
  }

  disconnectedCallback() {
    // Stop autoplay when the element is disconnected from the DOM.
    this.stopAutoplay();
  }
}

customElements.define('carousel-indicators', CarouselIndicators);
